export const ABOUT_1_CONSTANTS = {
    DEFAULT_ROW: {
      id: "1",
      meta_description: "Sample about description",
      meta_priority: 1,
    },

    // DEFAULT_ROW_1 for additional metadata
    DEFAULT_ROW_1: {
      id: "1",
      icon: "",
      alt_icon: "",
      title: "",
      description: "",
      title_color: "#000000",
      description_color: "#000000",
      priority: 1,
    },
  
    ABOUT_FIELDS_CONFIG: [
      {
        fieldName: "background_color",
        label: "Background Color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter background color (e.g., #FFFFFF)",
        required: false,
        defaultValue: "#FFFFFF",
      },
      {
        fieldName: "title",
        label: "About Title",
        value: "About Our Program",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter About Title",
        required: false,
        defaultValue: "About Our Program",
      },
      {
        fieldName: "title_text_color",
        label: "Title Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter title text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "description",
        label: "Description",
        value: "Learn more about our institution and programs",
        valueType: "string",
        filedType: "RICH_TEXT_EDITOR",
        placeholder: "Enter Description",
        required: false,
        defaultValue: "Learn more about our institution and programs",
      },
      {
        fieldName: "description_text_color",
        label: "Description Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter description text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "sub_text",
        label: "Sub Text",
        value: "",
        valueType: "string",
        filedType: "RICH_TEXT_EDITOR",
        placeholder: "Enter Sub Text",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "desktop_image",
        label: "Desktop Image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Desktop Image",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "mobile_image",
        label: "Mobile Image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Mobile Image",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "video_link",
        label: "Video Link",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Video Link",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "alt_image",
        label: "Alt Image Text",
        value: "About section image",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Alt Image Text",
        required: false,
        defaultValue: "About section image",
      },
      {
        fieldName: "read_more_text",
        label: "Read More Text",
        value: "Read More",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Read More Text",
        required: false,
        defaultValue: "Read More",
      },
      {
        fieldName: "read_more_color",
        label: "Read More Text Color",
        value: "#BE2330",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter read more text color (e.g., #BE2330)",
        required: false,
        defaultValue: "#BE2330",
      },
      {
        fieldName: "read_more_background_color",
        label: "Read More Background Color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter read more background color (e.g., #FFFFFF)",
        required: false,
        defaultValue: "#FFFFFF",
      },
      // {
      //   fieldName: "know_more_text",
      //   label: "Know More Button Text",
      //   value: "Know More",
      //   valueType: "string",
      //   filedType: "INPUT",
      //   placeholder: "Enter Know More Button Text",
      //   required: false,
      //   defaultValue: "Know More",
      // },
      // {
      //   fieldName: "know_more_text_color",
      //   label: "Know More Text Color",
      //   value: "#FFFFFF",
      //   valueType: "string",
      //   filedType: "COLOR",
      //   placeholder: "Enter know more text color (e.g., #FFFFFF)",
      //   required: false,
      //   defaultValue: "#FFFFFF",
      // },
      // {
      //   fieldName: "know_more_button_color",
      //   label: "Know More Button Color",
      //   value: "#BE2330",
      //   valueType: "string",
      //   filedType: "COLOR",
      //   placeholder: "Enter know more button color (e.g., #BE2330)",
      //   required: false,
      //   defaultValue: "#BE2330",
      // },
      // {
      //   fieldName: "know_more_icon",
      //   label: "Know More Icon",
      //   value: "",
      //   valueType: "string",
      //   filedType: "FILE",
      //   placeholder: "Upload Know More Icon",
      //   required: false,
      //   defaultValue: "",
      // },
      // {
      //   fieldName: "know_more_icon_alt",
      //   label: "Know More Icon Alt Text",
      //   value: "",
      //   valueType: "string",
      //   filedType: "INPUT",
      //   placeholder: "Enter Know More Icon Alt Text",
      //   required: false,
      //   defaultValue: "Know more",
      // },
      // {
      //   fieldName: "know_more_url",
      //   label: "Know More URL",
      //   value: "",
      //   valueType: "string",
      //   filedType: "INPUT",
      //   placeholder: "Enter Know More URL",
      //   required: false,
      //   defaultValue: "",
      // },
      {
        fieldName: "status",
        label: "About Status",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable About",
        defaultValue: false,
      },
      {
        fieldName: "enable_lead_form",
        label: "Enable Lead Form",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable Lead Form",
        required: false,
        defaultValue: false,
      },
      {
        fieldName: "is_open_leaddrop",
        label: "Is Open Lead Drop",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable Open Lead Drop",
        required: false,
        defaultValue: false,
      },
      {
        fieldName: "mobile_apply_now_text",
        label: "Mobile Apply Now Button Text",
        value: "Apply Now",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Mobile Apply Now Button Text",
        required: false,
        defaultValue: "Apply Now",
      },
      {
        fieldName: "mobile_apply_now_text_color",
        label: "Mobile Apply Now Text Color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter mobile apply now text color (e.g., #FFFFFF)",
        required: false,
        defaultValue: "#FFFFFF",
      },
      {
        fieldName: "mobile_apply_now_icon",
        label: "Mobile Apply Now Icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Mobile Apply Now Icon",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "mobile_apply_now_button_color",
        label: "Mobile Apply Now Button Color",
        value: "#BE2330",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter mobile apply now button color (e.g., #BE2330)",
        required: false,
        defaultValue: "#BE2330",
      }
    ],
  
    METADATA_FIELDS: [
      {
        header: "Description",
        fieldName: "meta_description",
        value: "",
        valueType: "string",
        filedType: "RICH_TEXT_EDITOR",
        placeholder: "Enter Meta Description",
      },
      {
        header: "Priority",
        fieldName: "meta_priority",
        value: "",
        valueType: "number",
        filedType: "INPUT",
        placeholder: "Enter Priority",
        required: true,
      },
    ],

    // METADATA_FIELDS_1 for additional metadata with icon, title, description, title color, description color
    METADATA_FIELDS_1: [
      {
        header: "Icon",
        fieldName: "icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Icon",
      },
      {
        header: "Alt Icon",
        fieldName: "alt_icon",
        value: "",
        valueType: "string",
        filedType: "TEXT_AREA",
        placeholder: "Enter Alt Icon Text",
      },
      {
        header: "Title",
        fieldName: "title",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Title",
      },
      {
        header: "Title Color",
        fieldName: "title_color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter title color (e.g., #000000)",
        defaultValue: "#000000",
      },
      {
        header: "Description",
        fieldName: "description",
        value: "",
        valueType: "string",
        filedType: "TEXT_AREA",
        placeholder: "Enter Description",
      },
      {
        header: "Description Color",
        fieldName: "description_color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter description color (e.g., #000000)",
        defaultValue: "#000000",
      },
      {
        header: "Priority",
        fieldName: "priority",
        value: "",
        valueType: "number",
        filedType: "INPUT",
        placeholder: "Enter Priority",
        //required: true,
      },
    ],
  };